(function($){
    if($('.quantity').length > 0){
        load_quantity_buttons();
    }
    $( document.body ).on( 'updated_cart_totals', function(event){
        load_quantity_buttons();
    });

    $('body').on('click', '.quantity .buttons a', function(e){
        e.preventDefault();
        var current = parseInt($(this).closest('.quantity').find('input').val());
        if($(this).hasClass('plus')){
            current++;
        }
        else{
            if(current > 1){
                current--;
            }
        }
        $(this).closest('.quantity').find('input').val(current);
        $(this).closest('.quantity').find('input').trigger('change');
        if($('[name="update_cart"]').length > 0){
            $('[name="update_cart"]').removeAttr('disabled');
            $('[name="update_cart"]').click();
        }
    })

    function load_quantity_buttons(){
        $('.quantity .buttons').remove();
        $('.quantity').append('<div class="buttons" />');
        $('.quantity .buttons').append('<a href="#" class="change-quantity plus"><img src="'+$('body').attr('data-select-arrow')+'" /></a>');
        $('.quantity .buttons').append('<a href="#" class="change-quantity minus"><img src="'+$('body').attr('data-select-arrow')+'" /></a>');
    }
})(jQuery)